export const PhoneFrame = ({ children, testid }) => (
  <div
    data-testid={testid}
    className="relative mx-auto w-full max-w-[380px] rounded-[2.6rem] border border-line-strong bg-[#070605] p-2.5 shadow-[0_40px_80px_-30px_rgba(0,0,0,0.8)]"
  >
    <div className="absolute left-1/2 top-4 z-20 h-6 w-28 -translate-x-1/2 rounded-full bg-[#070605]" />
    <div className="relative h-[700px] overflow-hidden rounded-[2.1rem] bg-ink">{children}</div>
  </div>
);
